import React, { useState, useEffect } from 'react';

export default function SplashScreen({ onComplete }) {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Start exit animation after 3.5 seconds
    const exitTimer = setTimeout(() => {
      setIsExiting(true);
    }, 3500);

    // Call onComplete after slide animation finishes (4 seconds total)
    const completeTimer = setTimeout(() => {
      onComplete();
    }, 4000);

    return () => {
      clearTimeout(exitTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div
      className={`fixed inset-0 bg-primary z-50 flex items-center justify-center transition-transform duration-500 ease-in-out ${
        isExiting ? '-translate-x-full' : 'translate-x-0'
      }`}
    >
      <div className="flex flex-col items-center">
        {/* Large TML Logo - All White */}
        <img
          src="/images/logo.png"
          alt="The Honourable Society of The Missing Links"
          className="w-64 h-auto md:w-80 animate-fade-in brightness-0 invert"
        />
      </div>
    </div>
  );
}
